// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!@css/utils");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._1M0CvpFfx{}._1M0CvpFfx{background-color:rgba(0,0,0,0.1);width:100%;margin:4px 0}._7e8x33rux{height:20px;max-width:300px}._1wsULKVnx{background-color:rgba(0,0,0,0.05);height:15px;max-width:200px}._3ctiUp00x{display:block;text-align:left;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Helvetica,Ubuntu,Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\";width:100%;margin-left:auto;margin-right:auto}@media (min-width: 768px){._3ctiUp00x{max-width:680px}}._7eaCiE4Wx{width:100%;margin-left:auto;margin-right:auto}@media (min-width: 768px){._7eaCiE4Wx{max-width:680px}}.HFozAyshx{padding:0 20px;border-bottom:1px solid var(--gray-8);overflow:hidden;max-width:calc(100vw - 20px * 2)}._5Ey9NIPmx{display:flex;margin:16px auto}._1id30tvgx{font-size:14px}.UqXgAnc3x{margin-left:auto;flex:none}._6csLK8OLx{margin-right:16px}._2y3QiJ6Nx{font-size:14px;width:100%;margin:16px 0}._2y3QiJ6Nx p{margin:5px 0}._5BOlenYhx{border-radius:15px;height:32px;text-transform:uppercase;font-size:14px;padding:0 8px;line-height:2}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"skeleton": "_1M0CvpFfx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + " _1M0CvpFfx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + "",
	"title-skeleton": "_7e8x33rux _1M0CvpFfx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + " _1M0CvpFfx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + "",
	"titleSkeleton": "_7e8x33rux _1M0CvpFfx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + " _1M0CvpFfx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + "",
	"paragraph-skeleton": "_1wsULKVnx _1M0CvpFfx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + " _1M0CvpFfx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + "",
	"paragraphSkeleton": "_1wsULKVnx _1M0CvpFfx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + " _1M0CvpFfx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + "",
	"unstyled-button": "_3ctiUp00x",
	"unstyledButton": "_3ctiUp00x",
	"responsive-constraint": "_7eaCiE4Wx",
	"responsiveConstraint": "_7eaCiE4Wx",
	"release": "HFozAyshx",
	"release-container": "_5Ey9NIPmx",
	"releaseContainer": "_5Ey9NIPmx",
	"title": "_1id30tvgx",
	"action": "UqXgAnc3x",
	"release-info": "_6csLK8OLx",
	"releaseInfo": "_6csLK8OLx",
	"release-notes": "_2y3QiJ6Nx",
	"releaseNotes": "_2y3QiJ6Nx",
	"install-button": "_5BOlenYhx",
	"installButton": "_5BOlenYhx"
};
module.exports = exports;
